module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"setMainClient":"Set as main client"},"fr":{"setMainClient":"Définir comme client principal"}}')
  delete Component.options._Ctor
}
